module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76RAV"))).then(() => parcelRequire('iDabs'));